export { default } from "./requirePropFactory.js";